import { Card, Table } from '@factorialco/deprecated-design-system'
import { AtsApplicationsSourceInsightsChartFragment } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import i18n from 'modules/core/lib/i18n'

import { DataNotAvailable } from 'modules/ats/components/Insights/DataNotAvailable'
import { getSourceLabel } from 'modules/ats/lib/utils/candidateSources'

import { ApplicationsSourceSkeleton } from './ApplicationsSourceSkeleton'

type Props = {
  applicationsSourceData: AtsApplicationsSourceInsightsChartFragment[]
  loading: boolean
}

const InnerContent = ({ applicationsSourceData, loading }: Props) => {
  const tableHeaders = [
    i18n.t('ats.insights_page.sources_metrics.table_headings.source'),
    i18n.t('ats.insights_page.sources_metrics.table_headings.total_candidates'),
    i18n.t('ats.insights_page.sources_metrics.table_headings.moved'),
    i18n.t('ats.insights_page.sources_metrics.table_headings.hired'),
  ]

  if (loading) {
    return <ApplicationsSourceSkeleton tableHeaders={tableHeaders} />
  }

  if (applicationsSourceData.length == 0) {
    return (
      <DataNotAvailable
        customMessage={i18n.t('ats.insights_page.empty_state.sources_metrics.description')}
      />
    )
  }

  return (
    <Table hideBorder fullWidth noRadius>
      <Table.Row>
        {tableHeaders.map((header) => (
          <Table.Cell key={header}>{header}</Table.Cell>
        ))}
      </Table.Row>
      {orderBy(applicationsSourceData, (insight) => insight.total, 'desc').map((insight) => (
        <>
          {!!insight.source && (
            <Table.Row key={insight.source.name}>
              <Table.Cell>{getSourceLabel(insight.source.name)}</Table.Cell>
              <Table.Cell>{insight.total}</Table.Cell>
              <Table.Cell>{insight.notInitial}</Table.Cell>
              <Table.Cell>{insight.hired}</Table.Cell>
            </Table.Row>
          )}
        </>
      ))}
    </Table>
  )
}

export const ApplicationsSourceChart = ({ applicationsSourceData, loading }: Props) => (
  <Card>
    <Card.Title>{i18n.t('ats.insights_page.sources_metrics.candidates_by_source')}</Card.Title>
    <Card.Content>
      <InnerContent loading={loading} applicationsSourceData={applicationsSourceData} />
    </Card.Content>
  </Card>
)
